import {
  createRouter,
  createWebHistory,
  createMemoryHistory,
  NavigationGuard,
  NavigationGuardWithThis,
  NavigationHookAfter,
  RouteRecordRaw
} from 'vue-router';
import { isClient } from '@vueuse/shared';
// eslint-disable-next-line
// @ts-nocheck
import { supportLanguages } from '@/config/site';
import langEach from './langEach';
import authEach from './authEach';
import stateEach from './stateEach';
import redirect from './redirect';
import routeList from './routes';

export const routes: RouteRecordRaw[] = [...routeList];

if (supportLanguages.length > 1) {
  // 生成多语言路由
  supportLanguages.forEach(lang => {
    const routeLangPath = lang.route || lang.iso;

    routeList.forEach(item => {
      routes.push({
        ...item,
        path: `/${routeLangPath}/${item.path.replace(/^\/+/, '')}`,
        meta: {
          ...item.meta
        }
      });

      if (['/spot/:symbolPath'].includes(item.path)) {
        // 静态化交易页
        const exchangePaths = ['/spot/BTC_USDT', '/spot/ETH_USDT', '/spot/XRP_USDT'];
        exchangePaths.forEach(path => {
          routes.push({
            ...item,
            path: `/${routeLangPath}/${path.replace(/^\/+/, '')}`,
            meta: {
              ...item.meta
            }
          });
        });
      }

      if (['/lite-perpetual/:symbolPath'].includes(item.path)) {
        const exchangePaths = ['/lite-perpetual/BTC-SWAP-USDT'];
        exchangePaths.forEach(path => {
          routes.push({
            ...item,
            path: `/${routeLangPath}/${path.replace(/^\/+/, '')}`,
            meta: {
              ...item.meta
            }
          });
        });
      }

      if (['/futures/:symbolPath'].includes(item.path)) {
        const exchangePaths = ['/futures/BTC-SWAP-USDT'];
        exchangePaths.forEach(path => {
          routes.push({
            ...item,
            path: `/${routeLangPath}/${path.replace(/^\/+/, '')}`,
            meta: {
              ...item.meta
            }
          });
        });
      }
    });
  });
} else {
  routeList.forEach(item => {
    routes.push({
      ...item,
      path: `/${item.path.replace(/^\/+/, '')}`,
      meta: {
        ...item.meta
      }
    });
  });
}

export const router = createRouter({
  history: isClient ? createWebHistory() : createMemoryHistory(),
  routes: routeList,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || {
      left: 0,
      top: 0
    };
  }
});

/**
 * 添加路由守卫
 *
 * @param {object|array} context 路由守卫
 */

type TypeContext = NavigationGuard[] | {
  beforeEach?: NavigationGuard[],
  afterEach?: NavigationHookAfter[]
};

const routerEach = (context: TypeContext, router: any) => {
  if (Array.isArray(context)) {
    context.forEach(item => router.beforeEach(item));
  } else {
    if (Array.isArray(context.beforeEach)) {
      context.beforeEach.forEach((item: NavigationGuardWithThis<undefined>) => router.beforeEach(item));
    }

    if (Array.isArray(context.afterEach)) {
      context.afterEach.forEach((item: NavigationHookAfter) => {
        router.afterEach(item);
      });
    }
  }
};

/**
 * routerEach 处理顺序：
 * 重定向 -> 登录态判断 -> URL语言处理 -> 页面状态处理
 *
 * 注：新增时要想好处理顺序，避免多余的重定向
 */
export const useRouterEach = (router: any) => {
  routerEach(redirect, router);
  routerEach(authEach, router);
  routerEach(langEach, router);
  routerEach(stateEach, router);
};
